// extracted by mini-css-extract-plugin
export default {"Title":"FolderPopupText_Title__l09s2","Subtitle":"FolderPopupText_Subtitle__d4d-3","Text":"FolderPopupText_Text__lrCyE","swing-in":"FolderPopupText_swing-in__99CHt"};